<template>
  <div class="settings mt-5">
    <b-row>
      <b-col md="12 text-center">
         <h5> Password Reset </h5>
      </b-col>
    </b-row>
    <b-row align-h="center">
        <b-col lg="5">
             <b-card-text>
             
               <b-form-group class="pt-2" v-if="showReset()">
                   <b-form-input
                    id="input-email"
                    type="email"
                    v-model="userForm.email"
                    required
                    placeholder="Enter email"
                  ></b-form-input>
                </b-form-group>
               <b-form-group class="pt-2" v-if="!showReset()">
                   <b-form-input
                    id="input-email"
                    type="email"
                    v-model="userForm.email"
                    disabled
                  ></b-form-input>
                </b-form-group>
                
                <b-form-group class="pb-2" v-if="!showReset()">
                  <b-form-input
                    id="input-password"
                    type="password"
                    v-model="userForm.password"
                    required
                    placeholder="Enter password"
                  ></b-form-input>
                </b-form-group>
                <b-form-group class="pb-2" v-if="!showReset()">
                  <b-form-input
                    id="input-passwordC"
                    type="password"
                    v-model="userForm.passwordC"
                    required
                    placeholder="Confirm password"
                  ></b-form-input>
                  <b-form-text id="password-help-block">
                    Your password must be 8-20 characters long, contain letters
                    and numbers, and must not contain spaces, special
                    characters, or emoji.
                  </b-form-text>
                 </b-form-group>
                 
                <b-form-group class="pb-2">
                  <b-form-text v-if="showReset() && !rq_submitted">
                    <b-button block variant="primary mt-4" :disabled=fieldsInvalid2()
                       @click="requestReset">
                       Request Reset
                    </b-button>
                  </b-form-text>
                  <b-form-text v-if="!showReset() && !rq_submitted">
                    <b-button block variant="success mt-4" :disabled=fieldsInvalid()
                      @click="changePassword">
                       Change Password
                    </b-button>
                  </b-form-text>
                </b-form-group>
              </b-card-text>
                  <b-form-text class="text-center">
                    <br/> Return to 
                    <router-link :to="{ name: 'login' }">
                       Login Page
                    </router-link>
                  </b-form-text>
      </b-col>
   </b-row>

  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";

export default {
  name: "register",
  data() {
    return {
      userForm: {
        email: "",
        password: ""
      },
      rq_submitted: false,
      preset_email: null,
      preset_token: null,
    };
  },
  components: {
  },
  created() {
    window.getUrlVars();
    if (window.vx && window.vx.preset_token) {
      this.userForm.email = this.preset_email = window.vx.preset_email;
      this.preset_token = window.vx.preset_token;
      delete window.vx.preset_token;
    } else {
      this.preset_token = null;
    }
  },
  methods: {
    showReset() {
      if (this.preset_email && this.preset_token) { return false; }
      return true;
    },
    fieldsInvalid2: function() {
      let vue = this;
      if (!vue.userForm.email) { return true; }
      return false;
    },
    fieldsInvalid: function() {
      let vue = this;
      if (!vue.userForm.email) { return true; }
      if (!vue.userForm.password) { return true; }
      if (!vue.userForm.passwordC) { return true; }
      return false;
    },
    goHome: function() {
      this.$router.push({ name: 'home' });
    },
    validateEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    requestReset: function() {
      let vue = this;
      if (!vue.validateEmail(vue.userForm.email)) {
        vue.$parent.notification = { alertCountDown: 4,
            alertVariant: "danger",
            alertMessage: "Email is invalid" };
        return;         
      }
      vue.rq_submitted = true;
      window.api_request_preset(window.vx, vue.userForm, function(err,data) {
        if (err) {
          vue.rq_submitted = false;
          vue.$parent.notification = { alertCountDown: 4,
             alertVariant: "danger",
             alertMessage: "Reset request failed." };
        } else {
          vue.$parent.notification = { alertCountDown: 6,
              alertVariant: "success",
              alertMessage: "Please check your email for reset instructions." };
        }
      });
    },
    changePassword: function() {
      let vue = this;
      if (vue.userForm.password.length <= 6) {
        vue.$parent.notification = { alertCountDown: 4,
            alertVariant: "danger",
            alertMessage: "Password is too short" };
        return;         
      }
      if (vue.userForm.password.length > 20) {
        vue.$parent.notification = { alertCountDown: 4,
            alertVariant: "danger",
            alertMessage: "Password is too long" };
        return;         
      }
      if (vue.userForm.password.match(/^[A-Z]+$/)) {
        vue.$parent.notification = { alertCountDown: 4,
            alertVariant: "danger",
            alertMessage: "Password needs more than uppercase letters" };
        return;
      }
      if (vue.userForm.password.match(/^[a-z]+$/)) {
        vue.$parent.notification = { alertCountDown: 4,
            alertVariant: "danger",
            alertMessage: "Password needs more than lowercase letters" };
        return;
      }
      if (vue.userForm.password.match(/^[0-9]+$/)) {
        vue.$parent.notification = { alertCountDown: 4,
            alertVariant: "danger",
            alertMessage: "Password needs more than numbers" };
        return;
      }
      if (vue.userForm.password != vue.userForm.passwordC) {
        vue.$parent.notification = { alertCountDown: 4,
            alertVariant: "danger",
            alertMessage: "Passwords do not match" };
        return;
      }
      vue.rq_submitted = true;
      vue.userForm.token = vue.preset_token;
      window.api_change_password(window.vx, vue.userForm, function(err,data) {
        if (err) {
          vue.rq_submitted = false;
          vue.$parent.notification = { alertCountDown: 4,
            alertVariant: "danger",
            alertMessage: "Password reset failed." };
       } else {
          vue.$parent.notification = { alertCountDown: 6,
            alertVariant: "success",
            alertMessage: "Please sign in using your new password." };
          //vue.goHome();
        }
      });
    }
  },
  computed: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 760px;
}
</style>
